export default "__VITE_ASSET__fcI8QNcn__"